import { jsx as o, Fragment as a } from "react/jsx-runtime";
import { Tooltip as e } from "../../atoms/Tooltip/Tooltip.es.js";
const i = ({
  children: r,
  tooltip: t
}) => t ? /* @__PURE__ */ o(e, { label: t, placement: "top", variant: "light", children: r }) : /* @__PURE__ */ o(a, { children: r });
export {
  i as FloatingActionWrapper
};
//# sourceMappingURL=FloatingActionWrapper.es.js.map
